var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnstarDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.859,
    height: 19.191,
    viewBox: "0 0 19.859 19.191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16093",
    "data-name": "Group 16093",
    transform: "translate(-1285.293 -596.727)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "star",
    d: "M16.954,6.434a.9.9,0,0,0-.777-.6l-4.907-.43L9.331,1.026a.917.917,0,0,0-1.662,0L5.729,5.406l-4.908.43a.9.9,0,0,0-.777.6.853.853,0,0,0,.264.926L4.017,10.5,2.923,15.145a.856.856,0,0,0,.351.9.929.929,0,0,0,.993.042L8.5,13.646l4.231,2.441a.93.93,0,0,0,.994-.042.856.856,0,0,0,.351-.9L12.981,10.5,16.69,7.36a.853.853,0,0,0,.264-.926ZM8.58,13.6",
    transform: "translate(1286.508 598.006)",
    fill: "none",
    stroke: "#383636",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16092",
    "data-name": "Group 16092",
    transform: "translate(1286 598)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x2: 17.256,
    y2: 16.646,
    transform: "translate(0.624 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13926",
    "data-name": "Path 13926",
    d: "M0,0,17.708,16.979",
    transform: "translate(0 0.161)",
    fill: "none",
    stroke: "#383636",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstarDark);
export default __webpack_public_path__ + "static/media/unstar-dark.cd4677d5.svg";
export { ForwardRef as ReactComponent };